import React from "react";
import {
  Col,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3030";

class EditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      overview: "",
      minPrice: "",
      maxPrice: "",
      detailLocation: "",
      city: "",
      street: "",
      userFoods: []
    };
    this.handleChangeFood = this.handleChangeFood.bind(this);
    this.handleChangeAddress = this.handleChangeAddress.bind(this);
    this.handleChangeCity = this.handleChangeCity.bind(this);
    this.handleChangeLocation = this.handleChangeLocation.bind(this);
    this.handleChangeDescriptionMenu = this.handleChangeDescriptionMenu.bind(
      this
    );
    this.handleChangeMinPrice = this.handleChangeMinPrice.bind(this);
    this.handleChangeMaxPrice = this.handleChangeMaxPrice.bind(this);
    this.editFood = this.editFood.bind(this);
  }

  handleChangeFood(event) {
    let value = event.target.value;
    this.setState(() => {
      return { name: value };
    });
  }

  handleChangeAddress(event) {
    let value = event.target.value;
    this.setState(() => {
      return { street: value };
    });
  }

  handleChangeCity(event) {
    let value = event.target.value;
    this.setState(() => {
      return { city: value };
    });
  }

  handleChangeLocation(event) {
    let value = event.target.value;
    this.setState(() => {
      return { inputLocation: value };
    });
  }

  handleChangeDescriptionMenu(event) {
    let value = event.target.value;
    this.setState(() => {
      return { inputDescriptionMenu: value };
    });
  }

  handleChangeMinPrice(event) {
    let value = event.target.value;
    this.setState(() => {
      return { minPrice: value };
    });
  }

  handleChangeMaxPrice(event) {
    let value = event.target.value;
    this.setState(() => {
      return { maxPrice: value };
    });
  }

  async editFood() {
    const arrayNumber = this.props.id;
    const id = this.props.userFoods[arrayNumber].id;
    console.log(id);
    await axios({
      url: `${API_URL}/foods/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + window.localStorage.token
      },
      data: {
        name: this.state.name,
        overview: this.state.inputDescriptionMenu,
        minPrice: this.state.minPrice,
        maxPrice: this.state.maxPrice,
        detailLocation: this.state.inputLocation,
        city: this.state.city,
        street: this.state.street
      }
    })
      .then(res => {
        console.log(res);
        this.props.toggle();
      })
      .catch(error => {
        console.log(error.res);
      });
  }
  render() {
    return (
      <div className="center">
        <Modal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.props.toggle}>Modal title</ModalHeader>
          <ModalBody className="modal-content">
            <div>
              <Form onSubmit={this.submitForm} className="addFoodForm">
                {/*Foodname Input*/}
                <FormGroup row>
                  <Label htmlFor="exampleFood" sm={2}>
                    FOOD NAME
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      id="foodname"
                      name="foodname"
                      placeholder="Insert Food Name"
                      value={this.state.name}
                      onChange={this.handleChangeFood}
                    />
                  </Col>
                </FormGroup>
                {/*Overview/Description input*/}
                <FormGroup row>
                  <Label htmlFor="exampleMenus" sm={2}>
                    DESCRIPTION MENU
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="textarea"
                      id="menus"
                      name="menus"
                      className="textarea-input"
                      placeholder="Insert Your Menu"
                      value={this.state.inputDescriptionMenu}
                      onChange={this.handleChangeDescriptionMenu}
                    />
                  </Col>
                </FormGroup>
                {/*Detail Location input*/}
                <FormGroup row>
                  <Label htmlFor="exampleAddress" sm={2}>
                    ADDRESS
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      id="address"
                      name="address"
                      placeholder="Insert Address"
                      value={this.state.street}
                      onChange={this.handleChangeAddress}
                    />
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label htmlFor="exampleCity" sm={2}>
                    CITY
                  </Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      id="city"
                      name="city"
                      placeholder="Insert City"
                      value={this.state.city}
                      onChange={this.handleChangeCity}
                    />
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label htmlFor="exampleLocation" sm={2}>
                    DETAIL LOCATION
                  </Label>
                  <Col sm={10}>
                    {/*<MapWithASearchBox />*/}
                    <Input
                      type="textarea"
                      id="price"
                      name="price"
                      className="textarea-input"
                      placeholder="Insert Detail Location of Your Food"
                      value={this.state.inputLocation}
                      onChange={this.handleChangeLocation}
                    />
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label htmlFor="examplePrice" sm={2}>
                    PRICE
                  </Label>
                  <Col sm={5}>
                    <Input
                      type="number"
                      name="Price"
                      placeholder="Insert Minimum Price"
                      value={this.state.minPrice}
                      onChange={this.handleChangeMinPrice}
                    />
                  </Col>
                  <Col sm={5}>
                    <Input
                      type="number"
                      name="Price"
                      placeholder="Insert Maximum Price"
                      value={this.state.maxPrice}
                      onChange={this.handleChangeMaxPrice}
                    />
                  </Col>
                </FormGroup>
              </Form>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.editFood}>
              Update
            </Button>
            <Button color="secondary" onClick={this.props.toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default EditModal;



// WEBPACK FOOTER //
// ./src/modal/EditModal.jsx